import { useNavigate, useLocation } from 'react-router-dom';
import { useUserStore } from '../../../store/useUserStore';
import Url from '../../../data/url';
import { useVideosByIntelligenceQuery } from '../../../queries';
import ImgNoThumbnail from '../../../assets/image/img_video_no_thumbnail.png';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import { useTranslation } from '../../../hook/useTranslation';

function IntelligenceVideos() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useUserStore();
  const { t } = useTranslation();
  const { intelligence } = (location.state as { intelligence: any }) || {};

  const { data: videos = [] } = useVideosByIntelligenceQuery(user.id as number, intelligence?.id, {
    enabled: !!user.id && !!intelligence?.id,
  });

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev
        title={t('history.video.intelligence_title', { label: t(`talent.${intelligence?.key}`) || intelligence?.label || '' })}
        onClickPrev={() => navigate(-1)}
      />
      <div className="pageInner" style={{ padding: '0 0 50px 0' }}>
        {videos.length >= 1 ? (
          <div className="grid grid-cols-3 gap-[5px] px-[20px]">
            {videos.map((video, index) => (
              <button
                type="button"
                onClick={() =>
                  navigate(Url.HistoryWatchVideo, { state: { videos, videoIndex: index } })
                }
                key={video.mediaId}
                style={{ aspectRatio: '1 / 1' }}
                className="w-full bg-[#F8F8F8] flex items-center justify-center text-[#1C1C1C] text-[14px] font-[500]"
              >
                <img
                  src={video.thumbnailUrl || ImgNoThumbnail}
                  alt={`Video ${video.mediaId}`}
                  className="w-full h-full object-cover rounded-[10px]"
                />
              </button>
            ))}
          </div>
        ) : (
          <div className="text-center h-[220px] flex items-center justify-center text-[#1C1C1C] text-[14px] font-[500]">
            {t('history.video.no_videos')}
          </div>
        )}
      </div>
    </FullHeightContainer>
  );
}

export default IntelligenceVideos;
